<div class="card hover-show w-100 overflow-auto d-flex flex-column position-relative">
    <div class="card-body flex-grow-1 d-flex flex-column">
        <app-confirmation-toggle *ngIf="appContext.isAdminOrIntermediary()">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Remove tax</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Are you sure you want to remove this item?</p>
                </div>
                <div class="modal-footer justify-content-between">
                    <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                    <button type="button" class="btn btn-primary" (click)="deleteTax()" data-bs-dismiss="modal">
                        Remove tax
                    </button>
                </div>
            </div>
            <button type="button" class="btn position-absolute top-0 end-0 to-show" role="button" aria-expanded="false">
                <i class="bi bi-trash"></i>
            </button>
        </app-confirmation-toggle>
        <div class="text-center mb-3">
            <h2 class="card-title">
                <app-connection-image [connectionType]="tax.taxInfo.connectionType"></app-connection-image>
                {{ tax.taxInfo.connectionType }}
            </h2>
            <h5 class="text-muted notranslate">
                {{tax.taxInfo.country}}
            </h5>
        </div>
        <div class="list-group-flush mb-n3 list-group flex-grow-1">
            <div *ngFor="let period of tax.taxPeriods;"
                 class="list-group-item py-3">
                <div class="row">
                    <div class="col-auto">
                        <i class="bi bi-calendar"></i>
                    </div>
                    <div class="col">
                        <small class="text-muted">
                            <app-contract-range [dateRange]="period.data.period" [isReadOnly]="true"></app-contract-range>
                        </small>
                    </div>
                    <div class="col-auto my-3 ms-2">
                        <button type="button" class="btn position-absolute top-0 end-0 to-show"
                                style="right: 24px !important;" role="button" aria-expanded="false" (click)="openTaxPeriodModal(period)">
                            <i class="bi bi-pencil"></i>
                        </button>
                    </div>
                    <div class="col-auto my-3">
                        <app-confirmation-toggle *ngIf="appContext.isAdminOrIntermediary()">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h3 class="modal-title">Remove period</h3>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <p>Are you sure you want to remove this tax period?</p>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="deleteTaxPeriod(period)">
                                        Remove period
                                    </button>
                                </div>
                            </div>

                            <button type="button" class="btn position-absolute top-0 end-0 to-show" role="button" aria-expanded="false">
                                <i class="bi bi-trash"></i>
                            </button>
                        </app-confirmation-toggle>
                    </div>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()"
                 class="list-group-item py-3 pointer hover-underline mt-auto" (click)="addNewTaxPeriod()">
                <div class="row">
                    <div class="col-auto">
                        <i class="bi me-2 bi-plus-circle"></i>
                    </div>
                    <div class="col text-truncate"><small>Add period</small></div>
                </div>
            </div>
        </div>
    </div>
</div>